// src/router/assets.ts
// Rotas do módulo de Gestão de Ativos (ITAM - IT Asset Management)
// Nota: A rota /asset-photo-upload/:token está definida em routes.ts como publicRoute
// IMPORTANTE: Todas as rotas ITAM consolidadas sob /itam/* - controle via banco de dados

import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';
import domainsChildRoutes from './domains';

const assetsRoutes: RouteRecordRaw[] = [
    // Todas as rotas ITAM consolidadas sob /itam/*
    {
        path: '/itam',
        component: FullLayout,
        meta: {
            requiresAuth: true,
            title: 'Gestão de Ativos (ITAM) - Hub AtlanGlobal'
        },
        children: [
            // Dashboards
            {
                path: 'dashboard',
                name: 'itam-dashboard',
                component: () => import('@/views/Assets/AssetsDashboard.vue'),
                meta: { title: 'Dashboard ITAM' }
            },
            {
                path: 'costs',
                name: 'itam-costs',
                component: () => import('@/views/Assets/CostDashboard.vue'),
                meta: { title: 'Dashboard de Custos' }
            },
            {
                path: 'reports',
                name: 'itam-reports',
                component: () => import('@/views/Assets/CostReports.vue'),
                meta: { title: 'Relatórios de Custo' }
            },
            // Dispositivos
            {
                path: 'devices',
                name: 'itam-devices',
                component: () => import('@/views/Assets/AssetsList.vue'),
                meta: { title: 'Dispositivos' }
            },
            {
                path: 'devices/new',
                name: 'itam-devices-new',
                component: () => import('@/views/Assets/AssetForm.vue'),
                meta: { title: 'Novo Dispositivo' }
            },
            {
                path: 'devices/:id',
                name: 'itam-devices-detail',
                component: () => import('@/views/Assets/AssetDetails.vue'),
                meta: { title: 'Detalhes do Dispositivo' }
            },
            {
                path: 'devices/:id/edit',
                name: 'itam-devices-edit',
                component: () => import('@/views/Assets/AssetForm.vue'),
                meta: { title: 'Editar Dispositivo' }
            },
            // Licenças
            {
                path: 'licenses',
                name: 'itam-licenses',
                component: () => import('@/views/Assets/LicensesList.vue'),
                meta: { title: 'Licenças' }
            },
            {
                path: 'licenses/new',
                name: 'itam-licenses-new',
                component: () => import('@/views/Assets/LicenseForm.vue'),
                meta: { title: 'Nova Licença' }
            },
            {
                path: 'licenses/:id',
                name: 'itam-licenses-detail',
                component: () => import('@/views/Assets/LicenseDetails.vue'),
                meta: { title: 'Detalhes da Licença' }
            },
            {
                path: 'licenses/:id/edit',
                name: 'itam-licenses-edit',
                component: () => import('@/views/Assets/LicenseForm.vue'),
                meta: { title: 'Editar Licença' }
            },
            // Telefonia
            {
                path: 'phone-lines',
                name: 'itam-phone-lines',
                component: () => import('@/views/Assets/PhoneLinesList.vue'),
                meta: { title: 'Linhas Telefônicas' }
            },
            {
                path: 'phone-lines/new',
                name: 'itam-phone-lines-new',
                component: () => import('@/views/Assets/PhoneLineForm.vue'),
                meta: { title: 'Nova Linha' }
            },
            {
                path: 'phone-lines/:id',
                name: 'itam-phone-lines-detail',
                component: () => import('@/views/Assets/PhoneLineDetails.vue'),
                meta: { title: 'Detalhes da Linha' }
            },
            {
                path: 'phone-lines/:id/edit',
                name: 'itam-phone-lines-edit',
                component: () => import('@/views/Assets/PhoneLineForm.vue'),
                meta: { title: 'Editar Linha' }
            },
            // Domínios
            ...domainsChildRoutes
        ]
    }
];

export default assetsRoutes;
